import { Link, useParams } from "react-router-dom";
import "./admin-email-detail.css";
import { useEffect, useMemo, useState } from "react";
import { HashLoader } from "react-spinners";
import ToastNotification, { showToast } from "../../components/toasts/ToastNotification";
import { getEmailsByAlias } from "../../api/gmail.api";
import { TbRefresh } from "react-icons/tb";
import { FiInbox } from "react-icons/fi";
import { MdOutlineAlternateEmail } from "react-icons/md";

export const AdminEmailDetail = () => {
  const { alias } = useParams();
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `Admin - Email ${alias}`;
  }, [alias]);

  useEffect(() => {
    fetchEmail();
  }, [alias]);

  const fetchEmail = async () => {
    try {
      setLoading(true);
      const res = await getEmailsByAlias(alias);
      if (res.success) setEmail(res.data || null);
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const emails = email?.emails || [];

  const summary = useMemo(
    () => ({
      total: emails.length,
      latestAt: emails[0]?.date ? new Date(emails[0].date).toLocaleString("vi-VN") : "-",
    }),
    [emails]
  );

  if (loading && !email) {
    return (
      <div className="loader-container">
        <HashLoader color="var(--hash-loader-color)" />
      </div>
    );
  }

  return (
    <section className="admin-email-detail-page">
      <ToastNotification />
      <div className="admin-email-detail-shell">
        <div className="admin-email-detail-head">
          <div>
            <p className="admin-email-detail-breadcrumb">
              <Link to="/super-admin/emails">Quản trị / Email</Link> / Chi tiết
            </p>
            <h1 className="admin-email-detail-title">Hộp thư đến</h1>
          </div>
          <button
            disabled={loading}
            onClick={fetchEmail}
            className="admin-email-detail-refresh-button"
            type="button"
          >
            <TbRefresh className="admin-email-detail-refresh-icon" />
            {loading ? "Đang tải..." : "Làm mới"}
          </button>
        </div>

        <div className="admin-email-detail-kpi">
          <div className="admin-email-detail-kpi-item">
            <span>Alias</span>
            <strong>{alias}</strong>
          </div>
          <div className="admin-email-detail-kpi-item">
            <span>Số thư</span>
            <strong>{summary.total}</strong>
          </div>
          <div className="admin-email-detail-kpi-item">
            <span>Mới nhất</span>
            <strong>{summary.latestAt}</strong>
          </div>
        </div>

        <div className="admin-email-detail-inboxes-container">
          {emails.length > 0 ? (
            emails.map((mail, index) => (
              <InboxCard key={`${mail?.subject || "mail"}-${mail?.date || index}`} mail={mail} />
            ))
          ) : (
            <div className="admin-email-empty-state">
              <FiInbox className="admin-email-empty-icon" />
              <p className="admin-email-empty-text">Chưa có thư đến cho alias này</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

const InboxCard = ({ mail }) => {
  return (
    <article className="admin-email-inbox-card">
      <h3 className="admin-email-inbox-subject">{mail?.subject || "(Không có tiêu đề)"}</h3>
      <div className="admin-email-inbox-meta">
        <p className="admin-email-inbox-row">
          <MdOutlineAlternateEmail />
          <span className="admin-email-inbox-label">Từ:</span>
          <strong>{mail?.from || "-"}</strong>
        </p>
        <p className="admin-email-inbox-row">
          <span className="admin-email-inbox-label">Thời gian:</span>
          <strong>{mail?.date ? new Date(mail.date).toLocaleString("vi-VN") : "-"}</strong>
        </p>
      </div>
      <p className="admin-email-inbox-body">{mail?.body || "-"}</p>
    </article>
  );
};
